import {
  animate,
  state,
  style,
  transition,
  trigger,
} from "@angular/animations";
import { AsyncPipe, CommonModule } from "@angular/common";
import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  OnDestroy,
  TemplateRef,
  ViewChild,
} from "@angular/core";
import { ActivatedRoute, Router, RouterModule } from "@angular/router";
import { Store } from "@ngxs/store";
import { BsDropdownModule } from "ngx-bootstrap/dropdown";
import { DndModule } from "ngx-drag-drop";
// import {
//   ScrollToConfigOptions,
//   ScrollToService,
// } from "@nicky-lenaers/ngx-scroll-to";
import { DOCUMENT } from "@angular/common";
import chroma from "chroma-js";
import { BsModalService } from "ngx-bootstrap/modal";
import { BsModalRef } from "ngx-bootstrap/modal/";
import { DndDropEvent } from "ngx-drag-drop";
import { PageScrollOptions, PageScrollService } from "ngx-page-scroll-core";
import { combineLatest, Observable, Subscription } from "rxjs";
import { map } from "rxjs/operators";
import { LearningObjectiveCategoriesSpellingComponent } from "../learning-objective-categories-spelling/learning-objective-categories-spelling.component";
import { LearningObjectiveCategoriesComponent } from "../learning-objective-categories/learning-objective-categories.component";
import { LearningObjectiveViewComponent } from "../learning-objective-view/learning-objective-view.component";
import { NavbarComponent } from "../navbar/navbar.component";
import { FilterComponent } from "../planning/filters.component";
import { getSubjectColor } from "../shared/helpers/util";
import { InlineEditComponent } from "../shared/inline-edit/inline-edit.component";
import {
  CitoApplicationModule,
  Domain,
  LearningObjective,
  LearningObjectiveVM,
  SelectedLearningObjective,
} from "../shared/model/model";
import { DashboardState } from "../shared/store/dashboard.state";
import {
  AddLearningObjectiveOrderAction,
  DeleteLearningObjectiveOrderAction,
  DisableLearningObjectiveInStructureAction,
  EnableLearningObjectiveInStructureAction,
  EnterEditModeAction,
  EnterReadOnlyModeAction,
  LearningObjectiveOrderState,
  LearningObjectiveOrderStateModel,
  LoadLearningObjectiveOrderListsAction,
  SelectDomainAction,
  SelectOrCopyLearningObjectiveOrderAction,
  UpdateLearningObjectiveOrderTitleAction,
} from "../shared/store/learning-objective-order.state";
import {
  AddLearningObjectiveAction,
  DeselectLearningobjectiveAction,
  LearningObjectiveData,
  LearningObjectivesState,
  LoadLearningObjectiveAction,
  RemoveLearningObjectiveAction,
  SelectLearningobjectiveAction,
  UpdateSelectedLearningObjectiveOrderAction,
} from "../shared/store/learning-objectives.state";
import { OrderCursorComponent } from "./order-cursor.component";
@Component({
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    AsyncPipe,
    BsDropdownModule,
    DndModule,
    NavbarComponent,
    InlineEditComponent,
    LearningObjectiveCategoriesComponent,
    LearningObjectiveCategoriesSpellingComponent,
    FilterComponent,
    LearningObjectiveViewComponent,
    OrderCursorComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: "app-orderlearning-objective",
  templateUrl: "./order-learning-objectives.component.html",
  styleUrls: ["./order-learning-objectives.component.scss"],
  animations: [
    trigger("editState", [
      state(
        "edit",
        style({
          height: 70,
        })
      ),
      state(
        "void",
        style({
          height: 0,
        })
      ),
      transition("void => *", animate("500ms ease-in")),
      transition("* => void", animate("500ms ease-out")),
    ]),
  ],
})
export class OrderLearningObjectivesComponent implements OnDestroy {
  @ViewChild(LearningObjectiveCategoriesComponent, { static: true })
  learningObjectiveCategoryComponent: LearningObjectiveCategoriesComponent;
  @ViewChild(LearningObjectiveCategoriesSpellingComponent, { static: true })
  learningObjectiveCategoryComponentSpelling: LearningObjectiveCategoriesSpellingComponent;
  public citomodules = CitoApplicationModule;
  selectedLearningObjectiveInList: LearningObjectiveVM;
  learningObjectiveData$: Observable<LearningObjectiveData>;
  learningObjectiveOrderData$: Observable<LearningObjectiveOrderStateModel>;
  domainIdInUrl = false;
  cursorIndex: number;
  mode = "view"; // Is Component in edit mode?
  modalRef?: BsModalRef;
  message: string;
  addedLoId: string;
  selectedLearningObjective$: Observable<SelectedLearningObjective>;
  selectedDomain$: Observable<Domain>;
  isCoordinator$: Observable<boolean>;
  selectedCitoModule$: Observable<CitoApplicationModule>;
  private routeParamSubscription: Subscription;
  private queryParamSubscription: Subscription;

  constructor(
    private store: Store,
    private route: ActivatedRoute,
    private router: Router,
    private modalService: BsModalService,
    private scrollToService: PageScrollService,
    @Inject(DOCUMENT) private document: Document
  ) {
    this.store.dispatch(new LoadLearningObjectiveAction());
    this.store.dispatch(new LoadLearningObjectiveOrderListsAction());
    this.selectedCitoModule$ = this.store.select(DashboardState.citomodule);
    this.citomodules = CitoApplicationModule;
    this.routeParamSubscription = combineLatest([
      route.params,
      this.store.select(LearningObjectiveOrderState.domains),
    ]).subscribe(([params, domains]) => {
      const selectedDomain = params["id"]
        ? params["id"]
        : domains && domains.length > 0
        ? domains[0].id
        : null;
      this.domainIdInUrl = !!selectedDomain;
      if (selectedDomain) {
        this.store.dispatch(new SelectDomainAction(selectedDomain));
      }
    });
    this.queryParamSubscription = route.queryParamMap
      .pipe(map((params) => params.get("edit") === "true" || false))
      .subscribe((edit) => {
        if (edit) {
          this.store.dispatch(new EnterEditModeAction());
        } else {
          this.store.dispatch(new EnterReadOnlyModeAction());
        }
      });
    this.learningObjectiveData$ = this.store
      .select(LearningObjectivesState.learningObjectives)
      .pipe(
        map((data) => {
          if (data && data.selectedLearningObjective) {
            this.selectedLearningObjectiveInList = {
              ...data.selectedLearningObjective,
              inList: true,
            };
          } else {
            this.selectedLearningObjectiveInList = null;
          }
          // Scroll to the learningObjective which was just added
          if (this.addedLoId) {
            const config: PageScrollOptions = {
              document: document,
              scrollTarget: this.addedLoId,
              duration: 1000,
              scrollOffset: 0,
            };
            setTimeout((a) => this.scrollToService.scroll(config), 500);
            this.addedLoId = null;
          }
          return data;
        })
      );
    this.learningObjectiveOrderData$ = this.store.select(
      LearningObjectiveOrderState as any
    );
    this.selectedDomain$ = this.store.select(
      LearningObjectiveOrderState.selectedDomain
    );
    this.isCoordinator$ = this.store.select(
      LearningObjectiveOrderState.isCoordinator
    );
  }

  ngOnDestroy() {
    if (this.queryParamSubscription) {
      this.queryParamSubscription.unsubscribe();
    }
    if (this.routeParamSubscription) {
      this.routeParamSubscription.unsubscribe();
    }
  }

  colorLightScale = (domainId: string, subjectId: string) => {
    const color = getSubjectColor(domainId, subjectId);
    return color ? chroma(color).luminance(0.8) : "transparent";
  };

  navigateToPlan = () => {
    this.router.navigate(["plan"]);
  };

  openInfoPage = () => {
    this.router.navigate(["/info"]);
  };

  /** MODAL */
  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, { class: "modal-sm" });
  }

  confirm(id: string): void {
    this.deleteLearningObjectiveOrder(id);
    this.modalRef?.hide();
  }

  decline(): void {
    this.modalRef?.hide();
  }
  /** MODAL */

  addLearningObjective = (lo: LearningObjectiveVM) => {
    this.addedLoId = "orderlist-" + lo.id;
    this.store.dispatch(new DisableLearningObjectiveInStructureAction(lo.id));
    this.store.dispatch(
      new AddLearningObjectiveAction(lo.id, this.cursorIndex)
    );
    this.store.dispatch(new SelectLearningobjectiveAction(lo));
    this.selectedLearningObjectiveInList = { ...lo, inList: true };
  };

  showInfo = (code: string) =>
    this.router.navigate(["learningObjective/" + code], {
      queryParams: this.route.snapshot.queryParams,
      relativeTo: this.route,
    });

  removeLearningObjective = (lo: LearningObjectiveVM) => {
    this.store.dispatch(new EnableLearningObjectiveInStructureAction(lo.id));
    this.store.dispatch(new RemoveLearningObjectiveAction(lo.id));
    this.selectedLearningObjectiveInList = { ...lo, inList: false };
  };

  selectLearningObjective = (lo: LearningObjectiveVM) => {
    if (lo && lo.inList) {
      this.store.dispatch(new SelectLearningobjectiveAction(lo));
      setTimeout(() => this.scrollToLearningObjective(lo), 200);
    } else {
      this.store.dispatch(new SelectLearningobjectiveAction(null));
    }
    this.selectedLearningObjectiveInList = lo;
  };

  onSave(id: string, name: string) {
    this.store.dispatch(new UpdateLearningObjectiveOrderTitleAction(id, name));
  }

  dropped = (e: DndDropEvent) =>
    this.store.dispatch(
      new UpdateSelectedLearningObjectiveOrderAction(e.data.id, e.index)
    );

  scrollToLearningObjective(lo: LearningObjective) {
    if (lo.id) {
      const config: PageScrollOptions = {
        document: document,
        scrollTarget: `orderlist-${lo.id}`,
        duration: 2000,
        scrollOffset: -20,
      };
      this.scrollToService.scroll(config);
    }
  }

  setSelectLearningObjective = (lo: LearningObjective, isSelected: boolean) => {
    if (!isSelected) {
      if (this.route.firstChild) {
        this.showInfo(lo.code);
      } else {
        this.store.dispatch(new SelectLearningobjectiveAction(lo));
      }
    } else {
      this.store.dispatch(new DeselectLearningobjectiveAction());
    }
  };
  identifyLO = (index: number, item: LearningObjective) => item.citoId;
  selectOrCopy = (id: string) =>
    this.store.dispatch(new SelectOrCopyLearningObjectiveOrderAction(id));
  createEmptyList = () =>
    this.store.dispatch(new AddLearningObjectiveOrderAction(null));
  deleteLearningObjectiveOrder = (id: string) =>
    this.store.dispatch(new DeleteLearningObjectiveOrderAction(id));

  showInStructure = (
    domainId: string,
    learningObjective: LearningObjective,
    selectedDomainId: string,
    document: any
  ) => {
    const config: PageScrollOptions = {
      document: document,
      scrollTarget: `categories-${learningObjective.id}`,
      duration: 1500,
      scrollOffset: 20,
    };

    if (domainId !== selectedDomainId) {
      this.router.navigate(["/domains/" + domainId], {
        queryParams: this.route.snapshot.queryParams,
      });
    } else {
      if (this.learningObjectiveCategoryComponent) {
        this.learningObjectiveCategoryComponent.expandSelectedLearningObjective();
        setTimeout(() => {
          this.scrollToService.scroll(config);
        }, 500);
      }
    }
  };
  toDomain = (domainId: string) =>
    this.router.navigate([`domains`, domainId], {
      queryParams: this.route.snapshot.queryParams,
    });
  toggleEditMode = (toEdit: boolean) =>
    this.router.navigate(
      this.route.snapshot.url.map((u) => u.path),
      {
        queryParams: { edit: toEdit },
      }
    );
}
